const ApiErrorModalIds = {
  ConnectionError: 'ApiConf_ConnectionErrorModal',
  ConcurrencyError: 'ApiConf_ConcurrencyErrorModal',
  AccessDenied: 'ApiConf_AccessDeniedModal',
  LoggedOut: 'ApiConf_LoggedOutModal',
  ServerError: 'ApiConf_ServerErrorModal',
} as const;

export default ApiErrorModalIds;
